import * as React from "react";

interface Props {
    color?: string;
    size?: number;
}
const DataBearing = (props: Props): JSX.Element => {
    const size = props.size ?? 20;
    const color = props.color ?? "#606060";
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10 7C14.1421 7 17.5 5.88071 17.5 4.5C17.5 3.11929 14.1421 2 10 2C5.85786 2 2.5 3.11929 2.5 4.5C2.5 5.88071 5.85786 7 10 7Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.5 10C17.5 11.1067 14.1667 12 10 12C5.83333 12 2.5 11.1067 2.5 10"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.5 4V15.5294C2.5 16.8965 5.83333 18 10 18C14.1667 18 17.5 16.8965 17.5 15.5294V4"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default DataBearing;
